// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"bc7278fd","488":"72b5f5b9"}[chunkId] + ".chunk.js";
};